//#region IMPORTS
import { ReactChild, ReactNode } from "react";
import { ArrowDownCircleIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "react-tooltip";
import ActionButton from "../genericButtons/actionButton/ActionButton";
import classNames from "../../helpers/classNames";
//#endregion

//#region INTERFACE
interface Props {
  hideuploadButtonPlusIcon2?: boolean;
  removeAllbuttonsWhenCRUD?: boolean;
  hideuploadButtonPlusIcon?: boolean;
  downloadClickHandler?: () => void;
  uploadClickHandler2?: () => void;
  downloadButtonValue?: string;
  uploadButtonValue2?: string;
  createClickHandler?: () => void;
  uploadClickHandler?: () => void;
  uploadButtonValue?: string;
  createButtonValue?: string;
  extraHQButtons?: ReactChild | null;
  extraButtons?: ReactChild | null;
  rightActions?: ReactNode;
  children?: ReactChild | null;
  disabled?: boolean;
  hqCanAdd?: boolean
  download?: boolean;
  upload2?: boolean;
  isAdmin?: boolean;
  hqTeam?: boolean;
  upload?: boolean;
  create?: boolean;
  extra?: any;
  title: string;
  reset?: () => void;
}
//#endregion

export default function PageHeader({
  hideuploadButtonPlusIcon2 = false,
  hideuploadButtonPlusIcon = false,
  removeAllbuttonsWhenCRUD = false,
  downloadButtonValue = "download",
  downloadClickHandler,
  uploadClickHandler2,
  uploadButtonValue2,
  createClickHandler,
  uploadClickHandler,
  uploadButtonValue,
  createButtonValue,
  extraHQButtons = null,
  extraButtons = null,
  rightActions = null,
  children,
  disabled = false,
  hqCanAdd = false,
  download = false,
  upload2 = true,
  isAdmin,
  hqTeam,
  upload,
  create,
  extra,
  title,
  reset,
}: Props) {
  //#region RENDER
  return (
    <header className="sticky top-24 z-[46] bg-white min-h-[8rem] pt-4">
      <div className="flex items-center justify-between">
        <div className="flex">
          {children}
          <h2
            data-tooltip-id={title}
            data-tooltip-content={reset ? "Reload data" : null}
            data-tooltip-place="right"
            onClick={reset}
            className={classNames(
              reset && "cursor-pointer hover:opacity-50",
              reset && disabled && "cursor-not-allowed",
              "font-semibold font-semibold text-5xl"
            )}
          >
            {title.charAt(0).toUpperCase() + title.slice(1)}
          </h2>
          <Tooltip id={title} />
        </div>
        {extra}

        {isAdmin ? (
          <div className="flex items-center justify-end gap-4">
            {rightActions}

            {/* Extra HQ buttons */}
            {extraHQButtons}

            {/* Extra buttons */}
            {extraButtons}

            {/* Download button */}
            {download && !removeAllbuttonsWhenCRUD && (
              <ActionButton
                clickHandler={downloadClickHandler}
                disabled={disabled}
                value={downloadButtonValue}
              >
                <ArrowDownCircleIcon
                  className="-ml-0.5 h-5 w-5"
                  aria-hidden="true"
                />
              </ActionButton>
            )}
            {!upload && !removeAllbuttonsWhenCRUD && uploadButtonValue && (
              <ActionButton
                hidePlusIcon={hideuploadButtonPlusIcon}
                clickHandler={uploadClickHandler}
                disabled={disabled}
                value={uploadButtonValue}
              />
            )}
            {!upload2 && !removeAllbuttonsWhenCRUD && uploadButtonValue2 && (
              <ActionButton
                hidePlusIcon={hideuploadButtonPlusIcon2}
                clickHandler={uploadClickHandler2}
                disabled={disabled}
                value={uploadButtonValue2}
              />
            )}
            {/* Create button */}
            {!create && !removeAllbuttonsWhenCRUD && createButtonValue && (
              <ActionButton
                clickHandler={createClickHandler}
                disabled={disabled}
                value={createButtonValue}
              />
            )}
          </div>
        ) : hqTeam && !isAdmin ? (
          <div className="flex items-center justify-end gap-4">
            {rightActions}

            {/* Extra HQ buttons */}
            {extraHQButtons}

            {/* Create button */}
            {!create && !removeAllbuttonsWhenCRUD && createButtonValue && hqCanAdd && (
              <ActionButton
                clickHandler={createClickHandler}
                disabled={disabled}
                value={createButtonValue}
              />
            )}
          </div>
        ) : rightActions ? (
          <div className="flex items-center justify-end gap-4">
            {rightActions}
          </div>
        ) : null}
      </div>
    </header>
  );
  //#endregion
}
